import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Check } from "lucide-react";
import { imgNbaLogo } from "../../../../assets";

export default function KYCStep5() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState<string | null>(null);

  const transactionTypes = [
    {
      id: "full",
      title: "Full Payment",
      description: "Complete the transaction with one payment",
    },
    {
      id: "installment",
      title: "Installmental Payment",
      description: "Split the payment into multiple installments",
    },
  ];

  const handleNext = () => {
    if (selectedType === "full") {
      navigate("/d/kyc/step7");
    } else if (selectedType === "installment") {
      navigate("/d/kyc/step6");
    }
  };

  return (
    <div className="kyc-page">
      <div className="kyc-header">
        <div className="kyc-logo-section">
          <img className="kyc-logo-img" src={imgNbaLogo} alt="NBA Logo" />
          <div className="kyc-logo-text">
            <div className="kyc-logo-name">NIGERIAN BAR ASSOCIATION</div>
            <div className="kyc-logo-sub">REMUNERATION PORTAL</div>
          </div>
        </div>
      </div>

      <div className="kyc-progress">
        <button
          className="kyc-back-button"
          type="button"
          onClick={() => navigate("/d/kyc/step4")}
          aria-label="Go back"
        >
          <ArrowLeft size={20} />
        </button>
        <div className="kyc-progress-content">
          <span className="kyc-progress-text">Step 5 of 7</span>
          <div className="kyc-progress-bar">
            <div className="kyc-progress-fill" style={{ width: "71.4%" }} />
          </div>
        </div>
      </div>

      <div className="kyc-container">
        <div className="kyc-content">
          <h1 className="kyc-title">Select Transaction Type</h1>
          <p className="kyc-subtitle">
            Choose how you would like to structure this transaction
          </p>

          <div className="kyc-transaction-types">
            {transactionTypes.map((type) => (
              <button
                key={type.id}
                className={`kyc-transaction-type-card ${
                  selectedType === type.id
                    ? "kyc-transaction-type-card--selected"
                    : ""
                }`}
                type="button"
                onClick={() => setSelectedType(type.id)}
              >
                <div className="kyc-transaction-type-header">
                  <span className="kyc-transaction-type-title">{type.title}</span>
                  <div className="kyc-transaction-type-radio">
                    {selectedType === type.id && <Check size={18} />}
                  </div>
                </div>
                <p className="kyc-transaction-type-desc">{type.description}</p>
              </button>
            ))}
          </div>

          <button
            className="dashboard-button dashboard-button--primary dashboard-button--large"
            type="button"
            onClick={handleNext}
            disabled={!selectedType}
          >
            <span>Next</span>
          </button>
        </div>
      </div>
    </div>
  );
}

